<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="aisle(row.id)">货道信息</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="updateState(row.id,'TY')" v-if="row.macDetailsName=='WC'">停用</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="updateState(row.id,'WC')" v-if="row.macDetailsName=='TY'">启用</Button>

			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				total: 0,
				deleteId: "", //修改状态的id
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '类型',
						key: 'macTypeName'
					},
					{
						title: '分类',
						key: 'macKindstString'
					},
					{
						title: '重量',
						key: 'weight'
					},
					{
						title: '最大存储量',
						key: 'maxCommodityNumber'
					},
					{
						title: '最大种类数',
						key: 'maxTypeNumber'
					},
					{
						title: '状态',
						key: 'macDetailsString',
						render: (h, params) => {
							if(params.row.macDetailsName=='TY'){
								return h('div',{
								style: {
								  color: 'red'
								}},params.row.macDetailsString);
							}else if(params.row.macDetailsName=='WC'){
								return h('div',{
								style: {
								  color: 'green'
								}},params.row.macDetailsString);
							}else{
								return h('div',{
								style: {
								  color: '#C7F709'
								}},params.row.macDetailsString);
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [],
				modal2: false,
				modal_loading: false,
				loading: false,
				query: { //查询条件
					page: '0',
					size: '10'
				}

			}
		},
		methods: {

			update(id) { //修改
				this.$router.push({
					name: 'jm/mac/machine/update',
					query: {
						id: id
					}
				})
			},
			aisle(id) { //货道信息
				this.$router.push({
					//name: 'jm/mac/aisle/list',
					name: 'jm/mac/aisle/add',
					query: {
						id: id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/mac/machine/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/details/page',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macDetails.totalElements
						_this.data6 = data.macDetails.content
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			}
		},
		components: {
			page
		},
		created() { //请求数据
			this.ajaxPage();
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/machine/list.vue